import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const GetFloorplanUploadUrlPathRequestSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
});
export const GetFloorplanUploadUrlResponseSchema = z.object({
    fields: z.record(z.string(), z.string()),
    floorplanId: z.string(),
    objectKey: z.string(),
    url: z.string(),
});
export const GetFloorplanUploadUrlApiSchema = {
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    params: GetFloorplanUploadUrlPathRequestSchema,
    response: GetFloorplanUploadUrlResponseSchema,
};
export const GetFloorplanUploadUrlRequestSchema = GetFloorplanUploadUrlPathRequestSchema.merge(GetFloorplanUploadUrlApiSchema.headers);
